import { useState } from 'react';
import { func } from 'prop-types';
import styled from 'styled-components';
import { useDebouncedCallback } from 'use-debounce';
import DefaultInput from '../../Forms/input';

const Input = styled(DefaultInput)`
  width: 250px;

  @media screen and (min-width: 768px) {
    margin-right: 32px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

function GridFilter ({ onSearchChange }) {
  const [searchValue, setSearchValue] = useState('');

  const setDebouncedSearch = useDebouncedCallback(() => {
    onSearchChange(searchValue.trim());
  }, 500);


  const handleSearchChange = (val) => {
    setSearchValue(val);
    setDebouncedSearch();
  };


  return (
    <Wrapper>
      <Input
        id="search"
        placeholder="Search..."
        value={searchValue}
        onChange={(ev) => handleSearchChange(ev.target.value)} />
    </Wrapper>
  );
}

GridFilter.propTypes = {
  onSearchChange: func.isRequired,
}

export default GridFilter;